import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const ProvidersEditToggle = ({ company, subcompany, provider, t }) => (
  <Form.Link
    className="btn btn-outline-primary btn-sm mx-2"
    to={createRoute(company.id, subcompany.id, `providers/${provider.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(ProvidersEditToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/list/actions/ProvidersActionsEdit.js